import { useLocation } from "react-router-dom";
import { useAdminAuth } from "@/frontend/contexts/AdminAuthContext";
import { User, Menu } from "lucide-react";
import { Button } from "@/frontend/components/ui/button";

const pageTitles: Record<string, string> = {
  "/admin": "Dashboard",
  "/admin/residences": "Residences",
  "/admin/rooms": "Rooms",
  "/admin/bookings": "Bookings",
  "/admin/contracts": "Contracts",
  "/admin/settings": "Settings",
};

interface AdminHeaderProps {
  onMenuToggle: () => void;
}

export const AdminHeader = ({ onMenuToggle }: AdminHeaderProps) => {
  const { user } = useAdminAuth();
  const location = useLocation();

  const getTitle = () => {
    const pathname = location.pathname;

    if (pageTitles[pathname]) {
      return pageTitles[pathname];
    }

    if (pathname.startsWith("/admin/contracts/")) {
      if (pathname.endsWith("/edit")) return "Edit Contract";
      if (pathname === "/admin/contracts/new") return "Create Contract";
      return "Contract Details";
    }

    if (pathname.match(/\/admin\/residences\/[^/]+\/regulations/)) {
      return "Regulations";
    }

    return "Admin";
  };

  const title = getTitle();

  return (
    <header className="bg-card border-b border-border px-4 sm:px-6 py-4 flex items-center gap-3">
      {/* Hamburger — mobile only, inside the header */}
      <Button
        variant="ghost"
        size="icon"
        className="lg:hidden flex-shrink-0"
        onClick={onMenuToggle}
      >
        <Menu className="h-5 w-5" />
      </Button>

      <h1 className="text-xl sm:text-2xl font-bold text-foreground flex-1 truncate">{title}</h1>

      <div className="flex items-center gap-2 text-muted-foreground flex-shrink-0">
        <User className="h-4 w-4" />
        <span className="text-sm hidden sm:inline truncate max-w-[160px]">{user?.email}</span>
      </div>
    </header>
  );
};
